module.exports = __webpack_public_path__ + "static/img/logo_white.c377133c.svg";